import React from "react"
import { Outlet } from "react-router-dom"
import { Layout, theme } from "antd"

import ReleaseAlert from "@components/ReleaseAlert"
import { getConfig } from "@components/Config"
import useUsersStore from "@stores/backstage/useUsersStore"
import { useAppContext } from "@components/AppContext"
import { ALERT_HEIGHT, SIDEBAR_WIDTH } from "@components/constants"

import Sidebar from "./Sidebar"
import { SecondFactorAlert } from "../../backstage"

const is2FaRequired = getConfig('is2FaRequired')


const ConsoleLayout = () => {
  const { token } = theme.useToken()
  const { colorBgContainer } = token

  const usersStore = useUsersStore()
  const { identity } = useAppContext()

  const { is2FaEnabled } = identity

  const layoutAlertsCount = [
    is2FaRequired && !is2FaEnabled
  ].filter(value => value).length

  const layoutTopOffset = layoutAlertsCount * ALERT_HEIGHT

  const context = {
    ...usersStore,
    layoutTopOffset,
  }

  const layoutProps = {
    style: {
      marginLeft: SIDEBAR_WIDTH,
      background: colorBgContainer,
    }
  }

  const isReady = !!usersStore.users

  return (
    <>
      <Sidebar />

      <Layout {...layoutProps}>
        <ReleaseAlert />
        <SecondFactorAlert />

        <Layout.Content>
          {
            isReady && (
              <Outlet context={context} />
            )
          }
        </Layout.Content>
      </Layout>
    </>
  )
}

export default ConsoleLayout
